import { ApiProperty } from "@nestjs/swagger";

export class AssetByAssetCode{
    @ApiProperty()
    assetsCode: string;

    @ApiProperty()
    assetCategory: string;

    @ApiProperty()
    plant: string;

    @ApiProperty()
    location: string;

    @ApiProperty()
    department: string;

    @ApiProperty()
    assetType: string; 
    
    @ApiProperty()
    employeeId: number;
    
    @ApiProperty()
    plantId: number;

    @ApiProperty()
    aging?: string;

    @ApiProperty()
    fromDate?:any;

    @ApiProperty()
    toDate?:any;

    @ApiProperty()
    assetSerialNo ?: string;
}